// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"WalkinCarousel_carouselWrapper__Q73Sx"};